import { render } from "./DropDown.vue?vue&type=template&id=510d90b3"
import script from "./DropDown.vue?vue&type=script&lang=js"
export * from "./DropDown.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whitebox-portal/whitebox-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__